/** @jsxFrag React.Fragment */

/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { LearnerProfile_ExternalLinks as ExternalLinksType } from '__generated__/graphql-types-do-not-use';

import { ExternalLinksItem } from 'bundles/account-profile/components/recruiting-profile-viewer/components/additional-info/ExternalLinksItem';

import facebookIcon from 'images/account-profile/facebook.svg';
import githubIcon from 'images/account-profile/github.svg';
import linkedinIcon from 'images/account-profile/linkedin.svg';
import twitterIcon from 'images/account-profile/twitter.svg';

import _t from 'i18n!nls/account-profile';

type ExternalLinksProps = {
  links: ExternalLinksType;
};

export const ExternalLinks = ({ links }: ExternalLinksProps) => {
  const { linkedin, facebook, twitter, github, default: other } = links;

  // TODO: These should be replaced with icons from CDS once they've been added
  const LinkedinIcon = () => <img src={linkedinIcon} alt={_t('LinkedIn icon')} />;
  const FacebookIcon = () => <img src={facebookIcon} alt={_t('Facebook icon')} />;
  const TwitterIcon = () => <img src={twitterIcon} alt={_t('Twitter icon')} />;
  const GithubIcon = () => <img src={githubIcon} alt={_t('Github icon')} />;

  return (
    <>
      {linkedin && <ExternalLinksItem icon={<LinkedinIcon />} url={linkedin} text={_t('LinkedIn')} />}
      {facebook && <ExternalLinksItem icon={<FacebookIcon />} url={facebook} text={_t('Facebook')} />}
      {twitter && <ExternalLinksItem icon={<TwitterIcon />} url={twitter} text={_t('Twitter')} />}
      {github && <ExternalLinksItem icon={<GithubIcon />} url={github} text={_t('Github')} />}
      {other && <ExternalLinksItem url={other} text={_t('Other')} />}
    </>
  );
};

export default ExternalLinks;
